module.exports = __webpack_public_path__ + "tenant-dashboard.cdb497ab6c3cafae28fc56bfcd5217ff.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/tenants/intro/tenant-dashboard.png
// module id = 8533678511406713
// module chunks = 1